/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

/** Ticket-level workType may be a display name string or an object with `name`. */
export const getTicketWorkTypeName = workType => {
  if (typeof workType === 'string') {
    return workType;
  }

  if (workType && typeof workType === 'object') {
    return workType?.name ?? '';
  }

  return '';
};
